export default __webpack_public_path__ + "static/media/Tomdown.9f0d4a36.mp3";